import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { User, Mail, Calendar } from 'lucide-react';

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
};

const AccountInfoCard = ({ profile }) => (
  <Card className="card-surface border-[#27272A]" data-testid="profile-info-card">
    <CardHeader>
      <CardTitle style={{ fontFamily: 'Outfit' }}>Account Information</CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="flex items-center gap-3">
        <User className="w-5 h-5 text-[#8B5CF6]" />
        <div><p className="text-sm text-[#A1A1AA]">Name</p><p className="text-base text-[#F9FAFB]">{profile.name}</p></div>
      </div>
      <div className="flex items-center gap-3">
        <Mail className="w-5 h-5 text-[#8B5CF6]" />
        <div><p className="text-sm text-[#A1A1AA]">Email</p><p className="text-base text-[#F9FAFB]">{profile.email}</p></div>
      </div>
      <div className="flex items-center gap-3">
        <Calendar className="w-5 h-5 text-[#8B5CF6]" />
        <div><p className="text-sm text-[#A1A1AA]">Member Since</p><p className="text-base text-[#F9FAFB]">{formatDate(profile.created_at)}</p></div>
      </div>
    </CardContent>
  </Card>
);

export default AccountInfoCard;
